export default __webpack_public_path__ + "static/media/collapse.5979252f.svg";